export const ESPECIALITATS_LISTING_BATCH_SIZE = 100;

export const RELATIVE_PATH_QUERY = {
  i: 'path',
  o: 'plone.app.querystring.operation.string.relativePath',
  v: '',
};

export function shouldDisablePagination(data) {
  if (data?.noPagination === true) {
    return true;
  }

  if (data?.noPagination === false) {
    return false;
  }

  return data?.variation === 'especialitats' || data?.variation === 'unitats';
}

export function usesCustomListing(data) {
  return data?.variation === 'noticies';
}

export function shouldUseQuerystringListing(data, hasQuery) {
  return hasQuery || shouldDisablePagination(data);
}

export function getEffectiveListingBatchSize(data, b_size) {
  return shouldDisablePagination(data)
    ? ESPECIALITATS_LISTING_BATCH_SIZE
    : b_size;
}

export function buildUnpaginatedListingQuery(querystring = {}, hasQuery) {
  const { limit, ...rest } = querystring;

  return {
    ...rest,
    b_size: ESPECIALITATS_LISTING_BATCH_SIZE,
    ...(hasQuery ? {} : { query: [RELATIVE_PATH_QUERY] }),
  };
}

export function applyListingBatchSize(data) {
  if (!shouldDisablePagination(data)) {
    return data;
  }

  const querystring = data.querystring || {};
  const hasQuery = querystring?.query?.length > 0;

  return {
    ...data,
    querystring: buildUnpaginatedListingQuery(querystring, hasQuery),
  };
}
